import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardText } from 'material-ui';
import RefreshIndicator from 'material-ui/RefreshIndicator';

const StatisticsCard = (props) => {
    const {
        data,
        isLoading,
        label,
        styles,
        title,
        weekLabel,
    } = props;

    const week = data.week ? `${ weekLabel } ${ data.week }` : '\u00a0';
    const value = data.value ? data.value : '-';
    const bookings = data.value ? `${ data.bookings } ${ label }` : null;

    return (
        <Card style={ styles.column } containerStyle={ styles.cardContainer }>
            { isLoading &&
                <RefreshIndicator size={ 40 } top={ 30 } left={ 0 } status={ 'loading' } style={ { marginLeft: '50%' } } />
            }

            <CardText>
                <div style={ styles.card.title }>{ title }</div>
                <div style={ styles.card.week }>{ week }</div>
                <div style={ styles.card.value }>{ value }</div>
                <div style={ styles.card.bookings }>{ bookings }</div>
            </CardText>
        </Card>
    );
};

StatisticsCard.propTypes = {
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    label: PropTypes.string,
    styles: PropTypes.object,
    title: PropTypes.string,
    weekLabel: PropTypes.string,
};

export default StatisticsCard;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/StatisticsCard.js